import { type PromoCodeId } from '../common/structs/orders/codes';

export const codes = () => ({
    collection: () => `/codes`,
    single: (id: PromoCodeId) => `/codes/${id}`,
});
